import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';

import { media } from '../../../styles';

const Container = glamorous.div({
  display: 'flex',
  alignSelf: 'flex-start',
  flexDirection: 'column',
  // flexDirection: 'row',
  // marginTop: 16,
  marginRight: 16,

  backgroundColor: '#ffffff',

  fontFamily: 'Roboto',
  fontWeight: '400',
  textTransform: 'uppercase',

  [media('sm')]: {
    flexDirection: 'column',
    width: 96,
    height: 96,
    flexBasis: 96,
    marginTop: 0,
    marginRight: 16,
  },
}, ({ theme }) => ({
  border: `1px solid ${theme.default.lightest}`,
  color: theme.primary.base,
}));

const Month = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 8,
  paddingRight: 8,

  color: '#ffffff',
  lineHeight: '1.2em',
  fontSize: '0.85em',
  textAlign: 'center',

  [media('sm')]: {
    lineHeight: '2em',
    fontSize: '1em',
  },

}, ({ theme }) => ({
  backgroundColor: theme.primary.base,
}));

const Day = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',

  fontSize: '1em',
  lineHeight: '1em',
  padding: 8,

  [media('sm')]: {
    fontSize: '1.5em',
  },
});

const Time = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  fontSize: '0.85em',
  lineHeight: '1em',
  fontWeight: '200',
  padding: 8,
}, ({ theme }) => ({
  [media('sm', { isMax: true })]: {
    // borderLeft: `1px solid ${theme.default.lightest}`,
  },
}));

class EventCalendar extends React.PureComponent {
  static propTypes = {
    day: PropTypes.number.isRequired,
    month: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
  };

  render() {
    const {
      day,
      month,
      time,
    } = this.props;

    return (
      <Container>
        <Month>
          {month}
        </Month>
        <Day>{day}</Day>
        <Time>
          {time}
        </Time>
      </Container>
    );
  }
}

export default EventCalendar;



// WEBPACK FOOTER //
// ./src/components/features/Event/EventCalendar.js